/* global process */ // only process.env.PUBLIC_URL, which vite.config.mjs `define` replaces at build time
export const BASE_PATH = process.env.PUBLIC_URL || '';

export const withBase = (path) =>
  `${BASE_PATH}${path.startsWith('/') ? path : `/${path}`}`;

export const originWithBase = () => `${window.location.origin}${BASE_PATH}`;
